import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

const LATITUDE_ASSINATURA = 'X-User-Latitude';
const LONGITUDE_ASSINATURA = 'X-User-Longitude';

const montarHeadersAssinatura = geolocalizacao => {
  const headers = {};

  if (geolocalizacao && geolocalizacao.latitude !== null && geolocalizacao.latitude !== undefined) {
    headers[LATITUDE_ASSINATURA] = String(geolocalizacao.latitude);
  }

  if (geolocalizacao && geolocalizacao.longitude !== null && geolocalizacao.longitude !== undefined) {
    headers[LONGITUDE_ASSINATURA] = String(geolocalizacao.longitude);
  }

  return headers;
};

export default {
  gerarIRPF: anoBase => {
    return Vue.http.get(`/api/pessoas/gerarIRPF/${anoBase}`)
      .then(resposta => resposta.data);
  },
  buscarAssinaturas: () => {
    return Vue.http.get(`/api/pessoas/buscarAssinaturas/`)
      .then(resposta => resposta.data);
  },
  buscarAssinatura: (id) => {
    return Vue.http.get(`/api/pessoas/buscarAssinatura/${id}`)
      .then(resposta => resposta.data);
  },
  buscarDetalhesAssinatura: id => {
    return Vue.http.get(`/api/pessoas/buscarDetalhesAssinatura/${id}`)
      .then(resposta => resposta.data);
  },
  downloadArquivoAssinatura: (idDocumentoAssinaturaAssinante, nome) => {
    return Vue.http.get(`/api/pessoas/downloadArquivoAssinatura/${idDocumentoAssinaturaAssinante}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, nome);
      });
  },
  downloadArquivoAssinaturaManifesto: (idDocumentoAssinaturaAssinante) => {
    return Vue.http.get(`/api/pessoas/downloadArquivoAssinaturaManifesto/${idDocumentoAssinaturaAssinante}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response);
      });
  },
  visualizarArquivoAssinatura: idDocumentoAssinaturaAssinante => {
    return Vue.http.get(`/api/pessoas/downloadarquivoassinatura/${idDocumentoAssinaturaAssinante}`, {
      responseType: 'blob'
    })
      .then(response => response.blob());
  },
  assinarDocumento: (idDocumentoAssinaturaAssinante, geolocalizacao = null) => {
    return Vue.http.get(`/api/pessoas/assinarDocumento/${idDocumentoAssinaturaAssinante}`, {
      headers: montarHeadersAssinatura(geolocalizacao)
    })
      .then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/pessoa-fisica/servico.js